import React, { useEffect, useState, useContext } from 'react'
import ConfigContext from '../ConfigContext'
import axios from 'axios'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import { setDialog } from '../store/actions/dialog'
import {
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Button,
  TextField,
  Box,
  Checkbox,
  FormControlLabel
} from '@material-ui/core'
import { ArrowDropUp, ArrowDropDown } from '@material-ui/icons'
import { makeStyles, Theme } from '@material-ui/core/styles'
import Title from '../components/atoms/Title'
import DefaultModal from '../components/atoms/DefaultModal'
import BannerUpload from '../components/organisms/BannerUpload'
import WebViewModal from '../components/organisms/WebViewModal'
// import {Banner} from '../types/Banner'

const validUrl = require('valid-url')

const useStyles = makeStyles((theme: Theme) => ({
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
    height: `100%`
  },
  imgContainer: {
    cursor: 'pointer'
  },
  bannerImage: {
    margin: '0 auto',
    width: 240,
    maxHeight: 154,
    objectFit: 'contain'
  },
  popUpImage: {
    height: '72vh',
    maxWidth: '1170px',
    maxHeight: '804px',
    objectFit: 'contain'
  },
  inputSort: {
    width: '50px'
  },
  previewImage: {
    width: '100%',
    maxWidth: '90vw',
    height: '100%',
    maxHeight: '90vh',
    objectFit: 'contain'
  }
}))

const BannerCMS: React.FC<ReturnType<typeof mapDispatchToProps>> = ({ setDialog }) => {
  const classes = useStyles({})
  const [banners, setBanners] = useState<
    {
      id: number
      image_path: string
      href: string
      sort: string
      close_flg: boolean
      member_flg: boolean
      member_site_flg: boolean
    }[]
  >([])
  const config = useContext(ConfigContext)
  const [isOpen, setIsOpen] = useState<boolean>(false)
  const [popUpImage, setPopUpImage] = useState<string>('')
  const [webViewUrl, setWebViewUrl] = useState('')
  const [modalState, setModalState] = useState(false)

  const fetchData = async () => {
    const { data } = await axios.get<{
      number_of_hits: number
      rows: {
        id: number
        image_path: string
        href: string
        sort: string
        close_flg: boolean
        member_flg: boolean
        member_site_flg: boolean
      }[]
    }>('/banners', {
      params: {
        sort: ['sort', 'id'],
        order: ['asc', 'desc']
      }
    })
    setBanners(data.rows)
  }

  /**
   * 初期化処理
   */
  useEffect(() => {
    fetchData()
  }, [])

  const handleUpdate = async () => {
    try {
      for (let i = 0; i < banners.length; i++) {
        if (!banners[i].href && banners[i].member_site_flg) {
          alert('会員のシームレスログインを許可する場合は画像のリンク先URLを入力してください。')
          return
        }
      }
      for (let i = 0; i < banners.length; i++) {
        delete banners[i]['created_at']
        delete banners[i]['modified_at']
      }
      setBanners(
        await Promise.all(
          banners.map(async banner => {
            const { data } = await axios.put<{
              id: number
              image_path: string
              href: string
              sort: string
              close_flg: boolean
              member_flg: boolean
              member_site_flg: boolean
            }>(`/banners/${banner.id}`, banner)
            return data
          })
        )
      )
      setDialog(
        '確認',
        '更新が完了しました',
        () => {},
        () => {},
        true
      )
    } catch (error) {
      alert(error.message)
    }
  }

  const handleDelete = async (index: number) => {
    try {
      setDialog(
        '確認',
        '削除してもよろしいですか？',
        async () => {
          const bannerId = banners[index].id
          await axios.delete(`/banners/${bannerId}`)
          fetchData()
        },
        () => {}
      )
    } catch (error) {}
  }

  const handleChangeCloseFlg = async (bannerId: number, checked: boolean) => {
    try {
      const { data } = await axios.put<{
        id: number
        image_path: string
        href: string
        sort: string
        close_flg: boolean
        member_flg: boolean
        member_site_flg: boolean
      }>(`/banners/${bannerId}`, {
        close_flg: checked
      })
      const _banners = banners.slice()
      setBanners(_banners.map((_banner, index) => (_banner.id === bannerId ? data : _banner)))
    } catch (error) {
      alert(error.message)
    }
  }

  // upで上へ、つまりソート番号としては数値を下げる
  // downで下へ、つまりソート番号としては数値を上げる
  const handleChangeSort = async (index: number, direction: 'up' | 'down') => {
    try {
      const targets = [...banners]
      const source = { ...targets[index] }
      if (direction === 'up') {
        const dest = { ...targets[index - 1] }
        targets.splice(index - 1, 2, source, dest)
      } else if (direction === 'down') {
        const dest = { ...targets[index + 1] }
        targets.splice(index, 2, dest, source)
      }
      await axios.put(
        `/banners/all`,
        targets.map((t, index) => ({ id: t.id, sort: index + 1 }))
      )
      fetchData()
    } catch (error) {
      alert(error.message)
    }
  }

  const LinkCheck = (urlString: string) => {
    if (validUrl.isWebUri(urlString)) {
      window.open(urlString)
      return
    } else {
      alert('不正なリンクURLです。変更してください。')
      window.open('/page-not-found')
      return
    }
  }

  return (
    <React.Fragment>
      <Grid item xs={12}>
        <Paper className={classes.paper}>
          <Title>画像の新規登録</Title>
          <BannerUpload uploadHandler={() => fetchData()} />
        </Paper>
      </Grid>

      <Grid item xs={12}>
        <Paper className={classes.paper}>
          <Title>アップロード済み画像</Title>
          <Box display="flex" justifyContent="flex-end" mb={7}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                handleUpdate()
              }}
            >
              情報を更新
            </Button>
          </Box>
          <Table size="small" padding="default">
            <TableHead>
              <TableRow>
                <TableCell align="center">画像</TableCell>
                {config.enableBannerPreview === '1' && (
                  <TableCell align="center">プレビュー</TableCell>
                )}
                <TableCell>リンクURL</TableCell>
                <TableCell align="center">並び順</TableCell>
                <TableCell align="center">表示／非表示</TableCell>
                <TableCell align="center">削除</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {banners.map((banner, index) => (
                <TableRow key={banner.id}>
                  <TableCell align="center">
                    <Box
                      height={154}
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      onClick={() => {
                        // s3対応
                        // setPopUpImage(
                        //   `${config.serverHost}/upload/image/?key=${encodeURIComponent(
                        //     banner.image_path
                        //   )}`
                        // )
                        setIsOpen(true)
                        setPopUpImage(banner.image_path)
                      }}
                      className={classes.imgContainer}
                    >
                      <img
                        src={`${config.serverHost}${banner.image_path}`}
                        // s3対応
                        // src={`${config.serverHost}/upload/image/?key=${encodeURIComponent(
                        //   banner.image_path
                        // )}`}
                        alt={banner.image_path}
                        className={classes.bannerImage}
                      />
                    </Box>
                  </TableCell>
                  {config.enableBannerPreview === '1' && (
                    <TableCell align="center">
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() => {
                          setWebViewUrl(
                            `${axios.defaults.baseURL}/previews/top-banner?img=${encodeURIComponent(
                              banner.image_path
                            )}`
                          )
                          setModalState(true)
                        }}
                      >
                        プレビュー
                      </Button>
                    </TableCell>
                  )}
                  <TableCell align="left">
                    <Box display="flex">
                      <TextField
                        value={banner.href}
                        onChange={(event: any) => {
                          const _banners = banners.slice()
                          _banners[index] = {
                            ...banner,
                            href: String(event.target.value)
                          }
                          setBanners(_banners)
                        }}
                        margin="normal"
                        variant="outlined"
                        placeholder="リンクURLを入力"
                        fullWidth
                      />
                      <Box display="flex" alignItems="center" ml={3}>
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={() => {
                            LinkCheck(banners[index].href)
                          }}
                          disabled={!banner.href || !banners[index].href}
                        >
                          リンク確認
                        </Button>
                      </Box>
                    </Box>
                    {config.enableBannerMemberFlg === '1' && (
                      <Box ml={2}>
                        <FormControlLabel
                          value="top"
                          control={
                            <Checkbox
                              checked={banner.member_flg}
                              onChange={(
                                event: React.ChangeEvent<HTMLInputElement>,
                                checked: boolean
                              ) => {
                                const _banners = banners.slice()
                                _banners[index] = {
                                  ...banner,
                                  member_flg: checked
                                }
                                setBanners(_banners)
                              }}
                            />
                          }
                          label="会員のみバナーを表示"
                          labelPlacement="end"
                        />
                      </Box>
                    )}
                    {config.enableBannerMemberSiteFlg === '1' && (
                      <Box ml={2}>
                        <FormControlLabel
                          value="top"
                          control={
                            <Checkbox
                              checked={banner.member_site_flg}
                              onChange={(
                                event: React.ChangeEvent<HTMLInputElement>,
                                checked: boolean
                              ) => {
                                const _banners = banners.slice()
                                _banners[index] = {
                                  ...banner,
                                  member_site_flg: checked
                                }
                                setBanners(_banners)
                              }}
                            />
                          }
                          label={
                            <span>
                              会員のシームレスログインを許可する
                              <br />
                              ※指定するURLが会員認証を必要とするサイトの場合、会員はシームレスにログインすることができます。
                            </span>
                          }
                          labelPlacement="end"
                        />
                      </Box>
                    )}
                  </TableCell>
                  <TableCell align="center">
                    <Box width={70} height={100} mx="auto">
                      <Box
                        display="flex"
                        height={100}
                        flexDirection="column"
                        justifyContent="space-around"
                      >
                        <Button
                          disabled={Number(banner.sort) <= 1}
                          variant="contained"
                          size="small"
                          color="primary"
                          onClick={() => {
                            handleChangeSort(index, 'up')
                          }}
                        >
                          <ArrowDropUp />
                        </Button>
                        {process.env.REACT_APP_NODE_ENV === 'local' && banner.sort}
                        <Button
                          disabled={Number(banner.sort) >= banners.length}
                          variant="contained"
                          size="small"
                          color="primary"
                          onClick={() => {
                            handleChangeSort(index, 'down')
                          }}
                        >
                          <ArrowDropDown />
                        </Button>
                      </Box>
                    </Box>
                  </TableCell>
                  <TableCell align="center">
                    <Button
                      variant="contained"
                      color={!Boolean(banner.close_flg) ? 'primary' : 'default'}
                      onClick={() => {
                        handleChangeCloseFlg(banner.id, !banner.close_flg)
                      }}
                    >
                      {!Boolean(banner.close_flg) ? '表示中' : '非表示'}
                    </Button>
                  </TableCell>
                  <TableCell align="center">
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => {
                        handleDelete(index)
                      }}
                    >
                      削除
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          <Box display="flex" justifyContent="flex-end" my={7}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                handleUpdate()
              }}
            >
              情報を更新
            </Button>
          </Box>
        </Paper>
      </Grid>
      <DefaultModal open={isOpen} onClose={() => setIsOpen(false)}>
        <Paper>
          <Box p={6} display="flex" justifyContent="center" alignItems="center">
            <img
              src={`${config.serverHost}${popUpImage}`}
              // s3対応
              // src={popUpImage}
              alt={popUpImage}
              className={classes.popUpImage}
            />
          </Box>
        </Paper>
      </DefaultModal>
      <WebViewModal
        isOpen={modalState}
        handleClose={() => setModalState(false)}
        url={webViewUrl}
        appliTopPage={true}
      />
    </React.Fragment>
  )
}

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    setDialog: (
      title: string,
      content: string,
      okHandler: () => void,
      ngHandler: () => void,
      noCancel?: boolean
    ) => dispatch(setDialog(title, content, okHandler, ngHandler, noCancel || false))
  }
}
export default connect(null, mapDispatchToProps)(BannerCMS)
